export enum timeFormats {
  dateWithHoursAndMinutes = 'YYYY-MM-DD_HH-mm',
  dateWithHoursAndMinutesAndSeconds = 'YYYY-MM-DDTHH:mm:ss',
  monthDateYear = 'MMMM DD, YYYY',
  monthDayYear = 'MMMM Do YYYY',
  dateMonYear = 'DD MMM YYYY',
  dateSlashMonSlashYear = 'DD/MM/YYYY',
  dateHypenMonthHypenYear = 'DD-MM-YYYY',
  dateMonthYear = 'DD MMMM YYYY',
  fullDateAndTime = 'MMM DD, YYYY HH:mm:ss:SSS',
  fullMonthDateYearTime = 'MMMM DD, YYYY LT',
  fullMonthDateYear = 'MMMM DD, YYYY ',
  fullMonthDateYearTimeWithSeconds = 'MMMM DD, YYYY LTS',
  fullMonthDateYearTimeWithSecondsDayJs = 'MMM DD, YYYY h:mm:ss A',
  monthDateTimeWithMeridiem = 'lll',
  monthDateCommaYear = 'LL',
  shortMonthDateYearTime = 'MMM DD YYYY, hh:mm A',
  dateMonth = 'DD MMM',
  dateAndTimeWithMeridiem = 'MMMM D, YYYY hh:mm A',
  dayMonthDateYearTimeWithMeridiemZoneOffset = 'dddd, MMMM D, YYYY, h:mm:ss A '
}
